<template>
  <Course />
</template>

<script lang="ts">
import { defineAsyncComponent, defineComponent } from "vue";

const Course = defineAsyncComponent(
  () => import("@/views/Course/CourseHome/course-home.vue")
);

export default defineComponent({
  name: "dashboardTeacher",
  components: { Course },
});
</script>
